import { FormikValues } from "formik";
import { Office } from "typings";
import { ROLES } from "./constants";

export const computedOfficeValue = (value?: string, offices?: Office[]) => {
  if (offices) {
    const office = offices.find(office => office.attributes.name === value);
    if (office) {
      return office.id;
    } else if (value) {
      return value;
    } else {
      return "default";
    }
  } else {
    return "default";
  }
};
export const disableRole = (values: FormikValues, role: any) => {
  if (values && values.supportedBy && values.supportedBy.length) {
    if (role.value === ROLES.ADMIN || role.value === ROLES.MEMBER) return true;
    if (values.role === ROLES.ATTORNEY && role.value !== ROLES.ATTORNEY) {
      return true;
    } else if (
      values.role !== ROLES.ATTORNEY &&
      role.value === ROLES.ATTORNEY
    ) {
      return true;
    }
  }
};
